export default __webpack_public_path__ + "static/2-8e5c84d371c4b5d67dfb66a4c79a3ad4.png";